/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m30 15.0205c.552 0 1 .447 1 1 0 .552-.448 1-1 1h-2.87c-.487 5.358-4.769 9.632-10.13 10.11v2.869c0 .553-.448 1-1 1s-1-.447-1-1v-2.869c-5.361-.478-9.643-4.752-10.13-10.11h-2.87c-.552 0-1-.448-1-1 0-.553.448-1 1-1h2.868c.47-5.378 4.757-9.672 10.132-10.151v-2.87c0-.552.448-1 1-1s1 .448 1 1v2.87c5.375.479 9.662 4.773 10.132 10.151zm-13 10.104c4.258-.463 7.648-3.849 8.122-8.104h-3.122c-.552 0-1-.448-1-1 0-.553.448-1 1-1h3.128c-.456-4.275-3.857-7.68-8.128-8.145v3.124c0 .553-.448 1-1 1s-1-.447-1-1v-3.124c-4.271.465-7.672 3.87-8.128 8.145h3.128c.552 0 1 .447 1 1 0 .552-.448 1-1 1h-3.122c.474 4.255 3.864 7.641 8.122 8.104v-3.125c0-.552.448-1 1-1s1 .448 1 1z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;